export class VendaParcela {
    vendaParcelaId: number = 0;
    dataVencimento: Date = new Date();
    valorParcela: number = 0;
    valorBruto: number = 0;
    textoAdicional: string = '';
    vendaId: number = 0;
    tipoPagamento: number = 0;
    saguiClienteId: number = 0;
}